import { render, staticRenderFns } from "./PersonnelSelector.vue?vue&type=template&id=08c48561&scoped=true&"
import script from "./PersonnelSelector.vue?vue&type=script&lang=ts&"
export * from "./PersonnelSelector.vue?vue&type=script&lang=ts&"
import style0 from "./PersonnelSelector.vue?vue&type=style&index=0&id=08c48561&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c48561",
  null
  
)

component.options.__file = "PersonnelSelector.vue"
export default component.exports